import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://jtwpjnzppaumnnneuatr.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp0d3BqbnpwcGF1bW5ubmV1YXRyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQzNzk1MzksImV4cCI6MjA3OTk1NTUzOX0.bq6AJFrSujU5DTOCowfWpk2Fh2bestYhkviie_FFE0s'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})